module.exports = __webpack_public_path__ + "static/media/nathan.98273e3b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/AdvisorsPartnersTeamResources/nathan.jpeg
// module id = 229
// module chunks = 0